export default __webpack_public_path__ + "static/media/loading.77f01013.svg";